import _ from "underscore";

export function getCurrentUser(state) {
    return state.UserReducer.user;
}

export function getCoinBalance(state) {
    return state.UserReducer.coinBalance;
}
